import { createApp } from "vue"
import ElementPlus from "element-plus"
import * as ElIcons from "@element-plus/icons-vue"
import locale from "element-plus/es/locale/lang/zh-cn"
import "element-plus/dist/index.css"
import "./assets/icon/iconfont.css"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./style/element.scss"
import { parseTime, getHeight, getLastDay } from "@/utils/index"
import {
  tableNameFilter,
  setUpStatusGsSb,
  setUpStatusQS,
  setUpStatusQSIcon,
  setUpStatusGsIconSb,
  batchSendSb,
  batchSendIconSb,
  batchSendWordSb,
  batchSendKk,
  batchSendWordKk,
  batchSendJc,
  batchSendCj,
  batchSendIconCj,
  setUpStatusGsZf,
  setUpStatusGsIconZf,
  setUpStatusGsWordZf,
  setUpStatusJzCj,
  setUpStatusJzCjIcon,
  yearAcessStatus,
  yearAcessIconStatus,
  yearAcessWordStatus,
  batchSendYearSb,
  filterAutoStatusText,
  homeTaxStatus,
  homeConfirmStatus
} from "@/utils/filter"
import { comdify } from "@/utils/fun"
const app = createApp(App)
app.mixin({
  methods: {
    $parseTime: parseTime,
    $getHeight: getHeight,
    $getLastDay: getLastDay,
    $batchSendSb: batchSendSb,
    $batchSendIconSb: batchSendIconSb,
    $batchSendWordSb: batchSendWordSb,
    $tableNameFilter: tableNameFilter,
    $batchSendKk: batchSendKk,
    $batchSendWordKk: batchSendWordKk,
    $batchSendJc: batchSendJc,
    $batchSendCj: batchSendCj,
    $batchSendIconCj: batchSendIconCj,
    $setUpStatusGsZf: setUpStatusGsZf,
    $setUpStatusGsIconZf: setUpStatusGsIconZf,
    $setUpStatusGsSb: setUpStatusGsSb,
    $setUpStatusGsWordZf: setUpStatusGsWordZf,

    $setUpStatusJzCj: setUpStatusJzCj,
    $setUpStatusJzCjIcon: setUpStatusJzCjIcon,
    $setUpStatusQS: setUpStatusQS,
    $setUpStatusQSIcon: setUpStatusQSIcon,
    $setUpStatusGsIconSb: setUpStatusGsIconSb,
    $yearAcessStatus: yearAcessStatus,
    $yearAcessIconStatus: yearAcessIconStatus,
    $yearAcessWordStatus: yearAcessWordStatus,
    $batchSendYearSb: batchSendYearSb,
    $filterAutoStatusText: filterAutoStatusText,
    $homeTaxStatus: homeTaxStatus,
    $homeConfirmStatus: homeConfirmStatus,
    $comdify: comdify,
  },
})
for (const iconName in ElIcons) {
  app.component(iconName, ElIcons[iconName])
}
app.use(ElementPlus, { locale }).use(store).use(router).mount("#app")
